<template>
  <div class="search">
    <div class="topcet">
      <input type="text" v-model="inputTxt" />
      <div class="topright" @click="serach">
        <p>検&nbsp;&nbsp;&nbsp;&nbsp;索</p>
        <p>（Search）</p>
      </div>
    </div>
    <div class="titletxt">
      <p>
        <span>ICCID</span> 番 号 入 力
      </p>
      <p>（Enter the ICCID number）</p>
    </div>
    <div class="centbox1">
      <div class="centtop">
        <p>
          <span>SIM</span>の設定容量：
        </p>
        <p>（Total balance）</p>
      </div>
      <div class="msg">
        <span v-if="isshow==1">{{flow}}MB</span>
        <span v-if="isshow==0">{{flow}}</span>
      </div>
    </div>
    <div class="centbox2">
      <div class="centcet">
        <p>残高容量：</p>
        <p>（Data balance）</p>
      </div>
      <div class="msg">
        <span v-if="isshow==1">{{surplusFlow}}MB</span>
        <span v-if="isshow==0">{{surplusFlow}}</span>
      </div>
    </div>
    <div class="centbox3">
      <div class="centbot">
        <p>
          <span>SIM</span>の有効期限：
        </p>
        <p>（Valid until）</p>
      </div>
      <div class="msg">
        <span v-if="isshow==0">SIM未開通です。{{expireDate}}までに開通してください。</span>
        <span v-if="isshow==1">{{expireDate}}</span>
      </div>
    </div>
    <div class="boxbot">
      ＜ご注意＞
      <br />１．ICCID番号はSIM本体に記入されています、下図位置表示されます。
      <br />２．「SIMの設定容量」はご契約いただいたSIMの全容量です。
      <br />３．「残高容量」が無くなると利用できなくなります。
      <br />４．「SIMの有効期限」表示は開通後の期限日です。
      <br />５．「SIMの有効期限」を経過すると残高容量があっても利用できなくなります。
      <br />６．未開通SIMの場合は「SIMの有効期限」にSIMの開通期限が表示されます。
      <br />※SIMの開通方法は当SIM をez:commu本機に差し込み初めて使用することで自動的に開通します。
    </div>
    <!-- <div class="img">
      <img src="../assets/iccid.png" alt="">
    </div>-->
  </div>
</template>

<script>
export default {
  data () {
    return {
      inputTxt: '',
      expireDate: '',
      flow: null,
      surplusFlow: null,
      isshow: 3
    }
  },
  methods: {
    serach () {
      // this.$message.error('カード番号の検証に失敗しました,もう一度入力してください。')
      if (!this.inputTxt) {
        this.$message.error('カード番号は空にできません')
        return
      }
      var that = this
      const loading = that.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      that
        .$get('/usedData/' + this.inputTxt, {})
        .then(res => {
          if (res.retCode == '0000') {// eslint-disable-line
            if (res.status == 1) {// eslint-disable-line
              if (res.tradeData.surplusFlow != '' && res.tradeData.Flow != '') {// eslint-disable-line
                this.flow = res.tradeData.flow
                this.surplusFlow = res.tradeData.surplusFlow
                this.isshow = 1
                this.expireDate = res.tradeData.expireDate
              } else {
                this.flow = ''
                this.surplusFlow = ''
                this.isshow = 0
                this.expireDate = res.tradeData.expireDate
              }
            }
            loading.close()
          } else {
            loading.close()
            this.$message.error(res.retMsg)
            this.cardNum = ''
            this.expireDate = ''
            this.flow = null
            this.surplusFlow = null
            this.isshow = 3
          }
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.search {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .topcet {
    display: flex;
    align-items: center;
    input {
      height: 50px;
      width: 400px;
      background-color: #a1b8e1;
      border: 0;
      padding: 0;
      font-size: 18px;
      padding: 0 10px;
    }
    .topright {
      margin-left: 10px;
      height: 40px;
      background: #4472c4;
      border-radius: 5px;
      padding: 2.5px 5px;
      p:nth-child(1) {
        font-size: 14px;
        font-weight: bold;
        padding: 0;
        margin: 0;
        color: #fff;
        text-align: center;
      }
      :hover {
        cursor: pointer;
      }
      p:nth-child(2) {
        font-size: 12px;
        padding: 0;
        margin: 0;
        color: #fff;
      }
    }
  }
  .titletxt {
    p:nth-child(1) {
      font-size: 16px;
      margin: 10px 70px 0 0;
      span {
        font-weight: bold;
      }
    }
    p:nth-child(2) {
      margin: 0px 70px 0 0;
      font-size: 12px;
      font-weight: bold;
    }
  }
  .centbox1 {
    text-align: left;
    width: 450px;
    display: flex;
    margin-top: 50px;
    .centtop {
      width: 130px;
      text-align: right;
      p:nth-child(1) {
        font-size: 16px;
        margin: 0;
        span {
          font-weight: bold;
        }
      }
      p:nth-child(2) {
        margin: 0;
        font-size: 12px;
        font-weight: bold;
      }
    }
    .msg {
      margin-top: 4px;
      span {
        font-weight: bold;
        margin-top: 5px;
      }
    }
  }
  .centbox2 {
    text-align: left;
    width: 450px;
    display: flex;
    margin-top: 15px;
    .centcet {
      width: 130px;
      text-align: right;
      p:nth-child(1) {
        font-size: 16px;
        margin: 0;
      }
      p:nth-child(2) {
        margin: 0;
        font-size: 12px;
        font-weight: bold;
      }
    }
    .msg {
      margin-top: 4px;
      span {
        font-weight: bold;
        margin-top: 5px;
      }
    }
  }
  .centbox3 {
    text-align: left;
    width: 600px;
    display: flex;
    margin-top: 15px;
    margin-left: 150px;
    .centbot {
      width: 130px;
      text-align: right;
      p:nth-child(1) {
        font-size: 16px;
        margin: 0;
        span {
          font-weight: bold;
        }
      }
      p:nth-child(2) {
        margin: 0;
        font-size: 12px;
        font-weight: bold;
      }
    }
    .msg {
      margin-top: 4px;
      span {
        font-weight: bold;
      }
    }
  }
  .boxbot {
    margin-top: 50px;
    width: 620px;
    font-size: 14px;
  }
  .img {
    position: absolute;
    right: 25%;
    top: 65%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue